import React from 'react';
import Axios from 'axios';
import { Table, Input, Form } from 'semantic-ui-react';

class Order extends React.Component {

    constructor(props) {
        super(props);
        this.loadProducts = this.loadProducts.bind(this);
        this.orderProductUpdated = this.orderProductUpdated.bind(this);
        this.descriptionUpdated = this.descriptionUpdated.bind(this);
        this.state = {
            products: [],
            order: {
                customerId: props.customer.id,
                products: [],
                subtotal: 0,
                total: 0,
                vat: 0,
                description: ""
            }
        };

        this.loadProducts();
    }

    loadProducts() {
        let self = this;
        Axios.get('http://165.227.166.190/products').then((res) => {
            if (res.data) {
                let orderProducts = [];
                res.data.forEach((product) => {
                    let orderProduct = {
                        name: product.name,
                        description: product.description,
                        productId: product.id,
                        qty: 0,
                        unit: product.unit,
                        price: product.price,
                        subtotal: 0,
                        vat: 0,
                        vatPer: product.vat,
                        total: 0
                    };
                    orderProducts.push(orderProduct);
                });
                self.setState((prevState) => {
                    let order = prevState.order;
                    order.products = orderProducts;
                    return {
                        order: order
                    };
                });
            }
        });
    }

    componentWillReceiveProps(props) {
        if (props.customer.id !== this.state.order.customerId) {
            this.setState((prevState) => {
                let order = prevState.order;
                order.customerId = props.customer.id;
                return {
                    order: order
                };
            });
        }
    }

    orderProductUpdated(e, productId) {
        let qty = 0;
        if (e.target.value !== "") {
            qty = parseInt(e.target.value, 10);
        }


        let order = this.state.order;
        order.vat = 0;
        order.subtotal = 0;
        order.total = 0;
        order.products.forEach((product) => {

            if (product.productId === productId) {
                product.qty = qty;
                product.subtotal = Math.round(product.price * qty);
                product.vat = Math.round(product.price * product.qty * Math.round(product.vatPer) / 100);
                product.total = Math.round(product.subtotal + product.vat);
            }

            order.subtotal += Math.round(product.subtotal);
            order.vat += Math.round(product.vat);
            order.total += product.total;
        });
        this.setState({
            order: order
        });
        this.props.onChange(order);
    }

    descriptionUpdated(e) {
        const value = e.target.value;
        this.setState(prevState => {
            const order = { ...prevState.order };
            order.description = value;
            this.props.onChange(order);
            return {
                order
            }
        });
    }

    render() {
        return (
            <div>
                <h2>Wat wil je bestellen?</h2>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Productnaam</Table.HeaderCell>
                            <Table.HeaderCell>Aantal</Table.HeaderCell>
                            <Table.HeaderCell>Subtotaal</Table.HeaderCell>
                            <Table.HeaderCell>Btw</Table.HeaderCell>
                            <Table.HeaderCell>Totaal</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            this.state.order.products.map((product) => {
                                return (
                                    <Table.Row key={product.productId}>
                                        <Table.Cell><p><strong>{product.name}</strong></p><p>{product.description}</p></Table.Cell>
                                        <Table.Cell><Input type="number" value={product.qty} onChange={(e) => this.orderProductUpdated(e, product.productId)} /></Table.Cell>
                                        <Table.Cell>€{(Math.round(product.subtotal * 100) / 100).toFixed(0)}</Table.Cell>
                                        <Table.Cell>€{(Math.round(product.vat * 100) / 100).toFixed(0)}</Table.Cell>
                                        <Table.Cell>€{(Math.round(product.total * 100) / 100).toFixed(0)}</Table.Cell>
                                    </Table.Row>
                                )
                            })
                        }
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell></Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                            <Table.HeaderCell>€{(Math.round(this.state.order.subtotal * 100) / 100).toFixed(0)}</Table.HeaderCell>
                            <Table.HeaderCell>€{(Math.round(this.state.order.vat * 100) / 100).toFixed(0)}</Table.HeaderCell>
                            <Table.HeaderCell>€{(Math.round(this.state.order.total * 100) / 100).toFixed(0)}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>

                <h2>Opmerkingen:</h2>
                <Form>
                    <Form.Field>
                        <Input type="text" value={this.state.order.description} onChange={this.descriptionUpdated} />
                    </Form.Field>
                </Form>

            </div>
        )
    }
}

export default Order;


// WEBPACK FOOTER //
// ./src/components/order/order.js